// User action Type
export const SET_LOCATION_LIST = "SET_LOCATION_LIST";
export const ADD_LOCATION = "ADD_LOCATION";
export const EDIT_LOCATION = "EDIT_LOCATION";
export const DELETE_LOCATION = "DELETE_LOCATION";
